import { Typography } from "@mui/material";

export function AiReviewPopupNotesSection({
  expanded,
  adminClampRef,
  adminExcerpt,
  adminText,
  reviewerText,
  authorText,
  includeAdmin = true,
  includeReviewer = true,
  includeAuthor = true,
  T,
}) {
  const hasAdmin = includeAdmin && !!adminText;
  const hasReviewer = includeReviewer && !!reviewerText;
  const hasAuthor = includeAuthor && !!authorText;
  const hasAnyNotes = hasAdmin || hasReviewer || hasAuthor;
  if (!expanded && !hasAnyNotes) return null;

  const collapsedTitle = hasAdmin ? "Admin notes" : hasReviewer ? "Reviewer notes" : "Author notes";
  const collapsedText = hasAdmin ? adminExcerpt : hasReviewer ? reviewerText : authorText;
  const collapsedDisplayText =
    typeof collapsedText === "string" ? collapsedText.replace(/…$/, "...") : collapsedText;
  const longTextStyle = {
    fontSize: 12,
    color: "#D7E3F0",
    lineHeight: 1.68,
    fontFamily: T.fontFamily,
    whiteSpace: "pre-wrap",
    letterSpacing: "0.01em",
  };
  const noteBg = T.surface1;
  const noteBorder = T.borderSubtle;

  return (
    <div style={{ padding: "0 16px", animation: "airp-slideUp 0.24s 360ms ease-out both", flex: "0 0 auto", minHeight: 0, display: "flex", flexDirection: "column" }}>
      {!expanded ? (
        <div style={{ background: noteBg, borderRadius: 10, border: `1.5px solid ${T.borderMedium}`, padding: "8px 12px 9px" }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.12em", color: T.textSecondary, textTransform: "uppercase", marginBottom: 6, fontFamily: T.fontFamily }}>
            {collapsedTitle}
          </div>
          <Typography
            ref={adminClampRef}
            sx={{
              fontSize: 12,
              color: "#D7E3F0",
              lineHeight: 1.68,
              letterSpacing: "0.01em",
              fontFamily: T.fontFamily,
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {collapsedDisplayText}
          </Typography>
        </div>
      ) : (
        <div className="ai-review-popup__notesScroll" style={{ display: "flex", flexDirection: "column", gap: 10, minHeight: 0 }}>
          {includeAdmin && (
            <div style={{ background: noteBg, borderRadius: 12, border: `1.5px solid ${T.borderMedium}`, padding: "12px 13px" }}>
              <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.12em", color: T.textSecondary, textTransform: "uppercase", marginBottom: 8, fontFamily: T.fontFamily }}>
                Admin view
              </div>
              <div style={longTextStyle}>
                {hasAdmin ? adminText : "No admin commentary supplied for this submission."}
              </div>
            </div>
          )}

          {includeReviewer && (
            <div style={{ background: noteBg, borderRadius: 12, border: `1.5px solid ${T.borderMedium}`, padding: "11px 13px" }}>
              <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.12em", color: T.textSecondary, textTransform: "uppercase", marginBottom: 8, fontFamily: T.fontFamily }}>
                Reviewer brief
              </div>
              <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 6, fontFamily: T.fontFamily }}>
                This is the guidance and framing the assigned reviewer is likely to receive.
              </div>
              <div style={longTextStyle}>
                {hasReviewer ? reviewerText : "No reviewer-facing brief has been generated for this submission."}
              </div>
            </div>
          )}

          {hasAuthor && (
            <div style={{ background: noteBg, borderRadius: 12, border: `1.5px solid ${T.borderMedium}`, padding: "11px 13px" }}>
              <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.12em", color: T.textSecondary, textTransform: "uppercase", marginBottom: 8, fontFamily: T.fontFamily }}>
                Author feedback
              </div>
              <div style={{ fontSize: 10, color: T.textMuted, marginBottom: 6, fontFamily: T.fontFamily }}>
                Useful context only. This is secondary to the admin and reviewer evidence above.
              </div>
              <div style={longTextStyle}>{authorText}</div>
            </div>
          )}
        </div>
      )}

    </div>
  );
}
